import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Favorite from "src/components/Favorite";
import Paid from "src/components/Paid";
import Rating from "src/components/Rating";
import constants from "src/constants";
import { sIntroductionAction } from "src/styles/sIntroductionAction.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  data: {
    paid?: boolean | null | undefined;
    isPaid?: boolean | null | undefined;
    subscription?: boolean | null | undefined;
    favorite: boolean;
    rating: number;
  };
};

function IntroductionActions({ style, className, data }: Props) {
  return (constants.Show.navRating && !(data.rating === undefined)) ||
    constants.Show.salePaidContent ||
    constants.Show.navFavorite ? (
    <div
      className={composeClassNames([
        sIntroductionAction,
        className,
        "introduction-actions",
      ])}
      style={style}
    >
      {data.paid && (
        <Paid
          paid={data.paid}
          isPaid={data.isPaid}
          subscription={data.subscription}
          size={`lg`}
          className={`video-paid`}
        />
      )}
      {constants.Show.navFavorite ? (
        <Favorite
          setByUser={true}
          className={`video-favorite`}
          value={data.favorite}
          colors={{
            default: constants.Theme.secondary,
            active: constants.Theme.primary,
          }}
          size={`lg`}
        />
      ) : null}
      {constants.Show.navRating && !(data.rating === undefined) ? (
        <Rating
          value={data.rating}
          className={`video-rating`}
          colors={{
            default: constants.Theme.secondary,
            active: constants.Theme.primary,
          }}
          size={`lg`}
        />
      ) : null}
    </div>
  ) : null;
}

export default IntroductionActions;
